import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faTwitter, faFacebookF, faInstagram,  } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faAngleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-sky-footer',
  templateUrl: './sky-footer.component.html',
  styleUrls: ['./sky-footer.component.scss']
})
export class SkyFooterComponent implements OnInit {

  faAngelRight = faAngleRight;
  faTwitter = faTwitter;
  faFacebookF = faFacebookF;
  faInstagram = faInstagram;
  faEnvelope = faEnvelope;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

}
